import './HamMenu.scss';
import HamMenuItem from './hamMenuItem/HamMenuItem';

export default function HamMenu(props) {
    if (!props.show) {
        return null;
    }

    return (
        <div className='hamMenu'>
            {
                props.menuItems.map(item => {
                    return (
                        <HamMenuItem
                            key={item.itemId}
                            languageElements={props.languageElements}
                            itemId={item.itemId}
                            isSelected={item.isSelected}
                            link={item.link}
                        />

                    )
                })

            }
        </div>
    )
}